import apiService from './ApiService';

/**
 * A tenant's balance and statement, and the one call that settles what they owe.
 */
export default class AccountApiService {

    /**
     * The signed-in tenant's balance, with every line behind it.
     * @return {Promise<ServiceResponse<AccountStatementDTO>>}
     */
    async getMyStatement() {
        const response = await apiService.getData('/api/Account/statement');

        return response.data;
    }

    /**
     * Pays off everything the signed-in tenant owes.
     *
     * Takes no user id: the account charged is whichever one the token belongs to, so there is no
     * version of this call that can be pointed at somebody else.
     *
     * @param request {PayBalanceRequestDto}
     * @return {Promise<ServiceResponse<PaymentReceiptDTO>>}
     */
    async payBalance(request) {
        const response = await apiService.postData('/api/Account/pay-balance', request);

        return response.data;
    }

    /**
     * Any tenant's statement. Admins only.
     * @param appUserId {number}
     * @return {Promise<ServiceResponse<AccountStatementDTO>>}
     */
    async getStatementForUser(appUserId) {
        const response = await apiService.getData(`/api/Account/admin/statement/${appUserId}`);

        return response.data;
    }

    /**
     * Every tenant currently carrying a balance, worst arrears first.
     * @return {Promise<ServiceResponse<Array<AccountStatementDTO>>>}
     */
    async getOutstandingAccounts() {
        const response = await apiService.getData('/api/Account/admin/outstanding');

        return response.data;
    }

    /**
     * Corrects a tenant's balance, for a write-off, a credit or a miscount.
     * @param adjustment {LedgerAdjustmentDto}
     * @return {Promise<ServiceResponse<LedgerEntryDTO>>}
     */
    async postAdjustment(adjustment) {
        const response = await apiService.postData('/api/Account/admin/adjustment', adjustment);

        return response.data;
    }
}
